import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5ea43e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "転職希望時期を教えてください")
], -1))
const _hoisted_4 = { class: "entry_base_input" }
const _hoisted_5 = { class: "entry_base_jobchange_date_list" }
const _hoisted_6 = { class: "entry_base_button" }
const _hoisted_7 = { class: "entry_base_button_prev" }
const _hoisted_8 = { class: "entry_base_button_next" }
const _hoisted_9 = { class: "entry_base_restart_account" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "no-wrap-text" }, "※過去にマスメディアンを利用されていた方は、", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { onBeforeMount, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import { useField, useForm } from 'vee-validate';
import { object, string, number } from 'yup';
import alertOnReload from '@/utils/alertOnReload';
import { getMasterDataList, Master } from '@/api/entryMasterDataEndpoint';

import Indicator from '@/components/Indicator.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';

type ChangeDateConvert = {
  value: number;
  label: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'WishJobChangeDateView',
  setup(__props) {

const changeDatesList = ref<Master[]>([]);
const changeDateConvert = ref<ChangeDateConvert[]>([]);

const schema = object({
  selectedChangeDateValue: number().required(),
});

const { errors } = useForm({
  validationSchema: schema,
});

const { value: selectedChangeDateValue } = useField('selectedChangeDateValue', undefined, {
  initialValue: store.getters['userRegistration/wishJobChangeDateId'],
});

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'a10' });
};
const transitionNextPage = () => {
  store.commit('userRegistration/setWishJobChangeDateId', selectedChangeDateValue.value);
  router.push({ name: 'b01' });
};

watch(selectedChangeDateValue, (newVal) => {
  if (newVal !== null && newVal !== undefined) {
    store.commit('userRegistration/setWishJobChangeDateId', newVal);
    router.push({ name: 'b01' });
  }
});

onBeforeMount(async () => {
  await store.dispatch('userRegistration/getCsrfToken');

  getMasterDataList('wishJobChangeDateId')
    .then((res) => {
     changeDatesList.value = res;
      changeDateConvert.value = changeDatesList.value.map((value) => {
        return { value: value.code, label: value.name };
      });
    })
    .catch((e) => {
      console.error(e);
    });
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 1,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(changeDateConvert.value, (changeDate) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "entry_base_jobchange_date_list_item",
              key: changeDate.value
            }, [
              _createVNode(BaseRadioButton, {
                modelValue: _unref(selectedChangeDateValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedChangeDateValue) ? (selectedChangeDateValue).value = $event : null)),
                value: changeDate.value,
                name: "changeDate",
                label: changeDate.label
              }, null, 8, ["modelValue", "value", "label"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseButton, {
            onClick: transitionNextPage,
            theme: "primary",
            type: "button",
            disabled: !_unref(selectedChangeDateValue)
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createTextVNode("【"),
            _createVNode(_component_router_link, {
              class: "text_link",
              to: { name: 'q01' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("転職支援サービスの再開をご希望の方")
              ]),
              _: 1
            }),
            _createTextVNode("】"),
            _hoisted_12,
            _createTextVNode("よりお手続きをお願いいたします ")
          ])
        ])
      ])
    ])
  ]))
}
}

})